import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SearchDataDispatcher } from './search-data.dispatcher';
import { SearchDataEffects } from './search-data.effects';
import { FEATURE_NAME, reducer } from './search-data.reducer';
import { SearchDataService } from './search-data.service';
import { SearchDataStore } from './search-data.store';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([SearchDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
})
export class SearchDataModule {
  static forRoot(): ModuleWithProviders<SearchDataModule> {
    return {
      ngModule: SearchDataModule,
      providers: [SearchDataDispatcher, SearchDataService, SearchDataStore],
    };
  }
}
